import { STATE_ABBREVIATIONS } from '@canyon/constants/location'

interface IIpInfoResponse {
  city?: string
  region?: string
}

const formatLocationString = (data: IIpInfoResponse): null | string => {
  if (data.city && data.region) {
    const stateAbbreviation =
      STATE_ABBREVIATIONS[data.region as keyof typeof STATE_ABBREVIATIONS] || data.region
    return `${data.city}, ${stateAbbreviation}`
  }
  return null
}

export const fetchUserLocation = async (): Promise<null | string> => {
  try {
    const response = await fetch('https://ipinfo.io/json')
    if (!response.ok) return null

    const data: IIpInfoResponse = await response.json()
    return formatLocationString(data)
  } catch (error) {
    console.error('Failed to fetch user location:', error)
    return null
  }
}
